import React from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { RecipientType } from '../types';

interface RecipientTypeSelectProps {
  value: RecipientType;
  onChange: (value: RecipientType) => void;
  isDisabled?: boolean;
  /** Naam van het contact — enkel voor de schermlezer, zodat de keuzes uit elkaar te houden zijn. */
  contactName?: string;
}

/**
 * Keuze tussen Aan, CC en BCC voor één ontvanger van een gezamenlijke mail.
 *
 * Bewust een native <select> in plaats van de shadcn/Radix Select: die rendert
 * zijn keuzelijst in een portal buiten de HeroUI-modal waarin de mass mail
 * draait. Een pointerdown in zo'n portal telt voor react-aria als "buiten de
 * modal" en sluit de volledige composer (met verlies van de opgestelde mail).
 * Het keuzelijstje van een native select leeft buiten de DOM en heeft dat
 * probleem niet.
 */
export const RecipientTypeSelect: React.FC<RecipientTypeSelectProps> = ({
  value,
  onChange,
  isDisabled = false,
  contactName,
}) => (
  <div className="relative shrink-0">
    <select
      value={value}
      disabled={isDisabled}
      onChange={(event) => onChange(event.target.value as RecipientType)}
      aria-label={contactName ? `Ontvangertype voor ${contactName}` : 'Ontvangertype'}
      title="Zet deze ontvanger in Aan, CC of BCC"
      className="h-8 w-[84px] cursor-pointer appearance-none rounded-md border border-input bg-background pl-2.5 pr-6 text-xs font-medium text-neutral-primary shadow-sm focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
    >
      <option value="to">Aan</option>
      <option value="cc">CC</option>
      <option value="bcc">BCC</option>
    </select>
    <CaretDown
      size={11}
      className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-neutral-secondary-mid"
    />
  </div>
);
